import type { CatalogUerBaseCostEstimateBasisRow, CollectionUerBaseCostEstimateBasisRow } from 'gql/graphql';
import type { GroupCollapseState } from 'pages/Project/UerProject/ActKC3List/components/ActKC3ListTable/types';
import { Button, IconArrowDown, IconArrowRight } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo } from 'react';

import type { TUerBaseCostEstimateBasisRow } from '../hooks/useUERBaseCostEstimateBasisRowsGrouped';

interface INumberCellRendererComponent
    extends ICellRendererParams<
        | TUerBaseCostEstimateBasisRow<CatalogUerBaseCostEstimateBasisRow>
        | TUerBaseCostEstimateBasisRow<CollectionUerBaseCostEstimateBasisRow>
    > {
    changeCollapseState: (groupKey: string) => () => void;
    collapseState: GroupCollapseState;
}

const style = { marginRight: 12, width: 16 };

export const NumberCellRendererComponent: React.FC<INumberCellRendererComponent> = (props) => {
    const { data, collapseState, changeCollapseState } = props;

    const areChildrenShown = useMemo(
        () => !(data?.groupKey && collapseState?.[data?.groupKey]),
        [collapseState, data?.groupKey],
    );

    return (
        <div>
            {!!data?.isGroup && (
                <Button
                    size="xs"
                    view="clear"
                    onlyIcon
                    iconRight={areChildrenShown ? IconArrowDown : IconArrowRight}
                    onClick={data?.isGroup && data?.groupKey ? changeCollapseState?.(data?.groupKey) : undefined}
                    style={style}
                />
            )}
            {data?.isSectionHeadLine ? data?.name : data?.number}
        </div>
    );
};

NumberCellRendererComponent.displayName = 'NumberCellRendererComponent';
